import { useSyncExternalStore } from 'react';
import { getProcessingMode, setProcessingMode, subscribeProcessingMode } from '@/lib/processingMode';

export default function ProcessingModeControl() {
  const mode = useSyncExternalStore(subscribeProcessingMode, getProcessingMode, () => 'local');
  return <div className="ml-auto flex flex-wrap items-center gap-3 text-xs">
    <span className={mode === 'cloud' ? 'text-amber-700' : 'text-gray-500'}>
      {mode === 'cloud' ? 'Cloud tools upload your file for processing.' : 'PDF tools process files on this device.'}
    </span>
    <label className="flex items-center gap-2 text-gray-700">Processing
      <select aria-label="PDF processing location" value={mode} onChange={(event) => setProcessingMode(event.target.value)} className="border border-gray-300 rounded-lg bg-white p-2">
        <option value="local">On this device</option>
        <option value="cloud">Cloud — upload file</option>
      </select>
    </label>
  </div>;
}
